<app-network-status-badge />

<div class="auth-wrapper">

  <!-- Brand -->
  <div class="brand">
    <img class="brand-logo" src="assets/Agos-logo-blue.png" alt="AGOS" />
    <p class="brand-subtitle">Weight &amp; Balance System</p>
  </div>

  <div class="network-hint" *ngIf="!isOnline()">
    <i class="bi bi-wifi-off"></i>
    <span><strong>You're offline.</strong> Reconnect to activate your license.</span>
  </div>

  <div class="auth-card">

    <!-- Header -->
    <h2 class="title">License Activation</h2>
    <p class="subtitle">
      Enter your 24-digit license key
    </p>

    <form class="w-100 flex flex-column">

      <!-- Single fixed-width field, grouped in 4s: 0000 0000 0000 0000 0000 0000 -->
      <app-segmented-input
        [(ngModel)]="licenceKey"
        name="licenceKey"
        [segments]="1"
        [segmentLength]="24"
        [groupSize]="4"
        pattern="alphanumeric"
        placeholder="0"
      />

      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <button class="primary-btn mt-3" type="submit" [disabled]="!licenceKey || !isOnline()" (click)="activateLicence()">
        Activate License
      </button>

    </form>
  </div>

  <p class="version-text">v{{ appVersion }}</p>
</div>
